@if (activeUserStore.isSuperAdmin()) {
  <p-selectButton
    styleClass="mb-4"
    [options]="modeOptions"
    [ngModel]="mode()"
    (ngModelChange)="mode.set($event)"
    [allowEmpty]="false"
    optionLabel="label"
    optionValue="value">
    <ng-template let-option pTemplate="item">
      <i [class]="option.icon" class="mr-2"></i>{{ option.label }}
    </ng-template>
  </p-selectButton>
}

@if (mode() === 'news') {
  <div class="release-notes">
    @for (release of releases(); track release.version; let latest = $first) {
      <section class="release" [class.release--latest]="latest">
        <header class="release__header">
          <div class="release__meta">
            @if (release.version) {
              <span class="release__version">Version {{ release.version }}</span>
            } @else {
              <span class="release__version release__version--next">
                <i class="fas fa-flask"></i> In Vorbereitung
              </span>
            }
            @if (release.dateLabel) {
              <span class="release__date">{{ release.dateLabel }}</span>
            }
            @if (latest && release.version) {
              <span class="release__latest">Aktuell</span>
            }
          </div>
          <h2 class="release__title">{{ release.title }}</h2>
        </header>

        @if (release.highlights.length) {
          <div class="release__highlights">
            @for (item of release.highlights; track item.title) {
              <article class="highlight">
                <span class="highlight__icon">
                  <i [class]="item.icon || types[item.type].icon"></i>
                </span>
                <div class="highlight__body">
                  <div class="highlight__tags">
                    <span class="tag tag--{{ item.type }}">
                      {{ types[item.type].label }}
                    </span>
                    <ng-container
                      *ngTemplateOutlet="badges; context: { $implicit: item }" />
                  </div>
                  <h3>{{ item.title }}</h3>
                  @if (item.text) {
                    <p>{{ item.text }}</p>
                  }
                </div>
              </article>
            }
          </div>
        }

        @for (group of release.groups; track group.type) {
          <h3 class="group__title group__title--{{ group.type }}">
            <i [class]="types[group.type].icon"></i>
            {{ types[group.type].label }}
          </h3>
          <ul
            class="group__items"
            [class.group__items--compact]="group.type === 'fixed'">
            @for (item of group.items; track item.title) {
              <li>
                <div class="item__head">
                  <strong>{{ item.title }}</strong>
                  <ng-container
                    *ngTemplateOutlet="badges; context: { $implicit: item }" />
                </div>
                @if (item.text) {
                  <p>{{ item.text }}</p>
                }
              </li>
            }
          </ul>
        }
      </section>
    }
  </div>
} @else {
  @if (changelog(); as state) {
    @if (isError(state)) {
      <p-message
        severity="error"
        text="Der Changelog konnte nicht geladen werden."></p-message>
    } @else {
      <article class="changelog" [innerHTML]="state.html"></article>
    }
  } @else {
    <div class="flex flex-column gap-3">
      <p-skeleton width="40%" height="2rem"></p-skeleton>
      <p-skeleton height="8rem"></p-skeleton>
      <p-skeleton height="12rem"></p-skeleton>
    </div>
  }
}

<ng-template #badges let-item>
  <span class="tag tag--area">{{ item.area }}</span>
  @if (item.beta) {
    <span class="tag tag--beta">Beta</span>
  }
  @if (item.audience === 'admin') {
    <span class="tag tag--admin" title="Nur für Administrator:innen sichtbar">
      <i class="fas fa-user-gear"></i> Für Admins
    </span>
  }
</ng-template>
